import { type ReactNode, useMemo } from 'react';

interface RenderWithOverflowProps<Item> {
  items: Item[];
  maxVisible: number;
  renderItem: (item: Item, index: number) => ReactNode;
  renderOverflow: (overflowItems: Item[], allItems: Item[]) => ReactNode;
}

export const RenderWithOverflow = <Item,>({
  items,
  maxVisible,
  renderItem,
  renderOverflow,
}: RenderWithOverflowProps<Item>) => {
  const { visibleItems, overflowItems } = useMemo(() => {
    const visibleItems = items.slice(0, maxVisible);
    const overflowItems = items.slice(maxVisible);
    return { visibleItems, overflowItems };
  }, [items, maxVisible]);

  return (
    <>
      {visibleItems.map((item, index) => renderItem(item, index))}
      {overflowItems.length > 0 && renderOverflow(overflowItems, items)}
    </>
  );
};
